import PhotographyComingSoon from '../Sections/PhotographyComingSoon'

function Photography() {
  return (
    <>
      <PhotographyComingSoon />
    </>
  );
}

export default Photography;
